import React, { useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Send, CheckCircle2 } from "lucide-react";

import { api } from "../../lib/api";

export default function InquiryForm({ packages = [], compact = false }) {
  const { register, handleSubmit, reset, formState: { errors, isSubmitting } } = useForm();
  const [done, setDone] = useState(false);

  const onSubmit = async (data) => {
    try {
      await api.post("/public/inquiry", { ...data, guests: data.guests ? parseInt(data.guests) : undefined });
      setDone(true); reset(); toast.success("Inquiry received! Our concierge will call you within 24 hours.");
    } catch (e) {
      toast.error("Could not submit. Please try again.");
    }
  };

  if (done) {
    return (
      <div className="border border-gold/30 bg-white p-10 text-center" data-testid="inquiry-success">
        <CheckCircle2 size={48} className="text-gold mx-auto" />
        <h3 className="serif text-3xl mt-4">Pranam · Thank You</h3>
        <p className="text-navy-900/50 mt-2 text-sm">Our team will reach out personally within 24 hours.</p>
        <button onClick={() => setDone(false)} className="btn-outline mt-6">Submit another</button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="bg-white border border-gold/30 p-7 lg:p-9 royal-card" data-testid="inquiry-form">
      <div className="label-eyebrow">Concierge Inquiry</div>
      <div className="serif text-2xl mt-1 mb-6">A private proposal awaits.</div>

      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="label">Name</label>
          <input className="input" placeholder="Your full name" {...register("name", { required: true })} data-testid="inquiry-name" />
          {errors.name && <div className="text-maroon text-xs mt-1">Required</div>}
        </div>
        <div>
          <label className="label">Phone</label>
          <input className="input" placeholder="+91 9876543210" {...register("phone", { required: true })} data-testid="inquiry-phone" />
          {errors.phone && <div className="text-maroon text-xs mt-1">Required</div>}
        </div>
        <div className="sm:col-span-2">
          <label className="label">Email</label>
          <input className="input" type="email" placeholder="you@example.com" {...register("email")} data-testid="inquiry-email" />
        </div>
        <div>
          <label className="label">Event Type</label>
          <select className="input" {...register("event_type")} data-testid="inquiry-event-type">
            <option value="">Select…</option>
            <option>Wedding</option><option>Sangeet / Mehendi</option><option>Engagement</option>
            <option>Corporate</option><option>Birthday</option><option>Destination</option><option>Canteen Contract</option><option>Other</option>
          </select>
        </div>
        <div>
          <label className="label">Event Date</label>
          <input className="input" type="date" {...register("event_date")} data-testid="inquiry-date" />
        </div>
        <div>
          <label className="label">Expected Guests</label>
          <input className="input" type="number" placeholder="200" {...register("guests")} data-testid="inquiry-guests" />
        </div>
        <div>
          <label className="label">Preferred Package</label>
          <select className="input" {...register("package")} data-testid="inquiry-package">
            <option value="">Suggest one for me</option>
            {packages.map(p => <option key={p.id} value={p.slug}>{p.name} · ₹{p.price}/plate</option>)}
          </select>
        </div>
        <div className="sm:col-span-2">
          <label className="label">Venue / City</label>
          <input className="input" placeholder="Vadodara · Akota" {...register("venue")} data-testid="inquiry-venue" />
        </div>
        <div className="sm:col-span-2">
          <label className="label">Message</label>
          <textarea className="input min-h-[100px]" placeholder="Tell us about your vision…" {...register("message")} data-testid="inquiry-message" />
        </div>
      </div>

      <button type="submit" disabled={isSubmitting} className="btn-gold mt-6 w-full justify-center" data-testid="inquiry-submit">
        {isSubmitting ? "Sending…" : <>Submit Inquiry <Send size={14} /></>}
      </button>
    </form>
  );
}
